import { Attribute, Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { WzValidators } from '@wz-validators';

@Directive({
  // tslint:disable-next-line:directive-selector : overriding built-in selectors
  selector:
    '[stringNotEmptyAndTrimmed][formControlName],[stringNotEmptyAndTrimmed][formControl],[stringNotEmptyAndTrimmed][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => StringNotEmptyAndTrimmedDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class StringNotEmptyAndTrimmedDirective implements Validator {
  constructor(@Attribute('StringNotEmptyAndTrimmed') public test: any) {}

  validate(thisControl: AbstractControl): { [key: string]: any } | any {
    return WzValidators.stringNotEmptyAndTrimmed(thisControl);
  }
}
